module.exports = __webpack_public_path__ + "static/media/Poppins-Light.f6ea751e.ttf";